import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

const isTravelersTripRoute = (route: RouteLocationNormalized) => route.path.includes('/travelers/trip/')

export const NavigationGuard = {
  appendItineraryIdToBookingRoutes: (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext,
  ) => {
    if (isTravelersTripRoute(to) && isTravelersTripRoute(from)) {
      const hasNewQueryParams = Object.keys(from.query).some(key => !to.query[key])

      if (hasNewQueryParams) {
        next({
          ...to,
          query: {
            ...from.query,
            ...to.query,
          },
        })
      } else {
        next()
      }
    } else {
      next()
    }
  },
  appendReferrerToUrl: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
    const hasSourceQueryParams = Object.keys(from.query).length > 0

    if (hasSourceQueryParams) {
      const mergedQuery = { ...from.query, ...to.query }
      const hasDifferentQueryParams = JSON.stringify(to.query) !== JSON.stringify(mergedQuery)

      if (hasDifferentQueryParams) {
        next({
          ...to,
          query: mergedQuery,
        })
      } else {
        next()
      }
    } else {
      next()
    }
  },
}
